import React from "react"

import { Button } from "components/Button"
import { ClientListModal } from "components/Modal"
import { TagList } from "components/Tag"
import { removePkdDuplicates } from "pages/NewsletterPages/add/Steps/SelectNewsPage/GroupedClientsBySelectedNews"
import {
  NewsletterForPreviewDtoResponse,
  NewsletterWithStatsDto
} from "types/Newsletter"
import usePrefix from "utils/usePrefix"

interface NewsletterClientModalProps {
  isVisible: boolean
  title: string
  newsletterList: (NewsletterWithStatsDto | NewsletterForPreviewDtoResponse)[]
  isClientRemovable?: boolean
  clientIds?: string[]
  onClientRemove?: (id: string) => void
  onClose: () => void
}

export const NewsletterClientModal: React.FC<NewsletterClientModalProps> = ({
  isVisible,
  isClientRemovable,
  title,
  newsletterList,
  clientIds,
  onClientRemove,
  onClose
}) => {
  const tGeneral = usePrefix("General")

  const tags = Array.from(
    new Set(newsletterList.flatMap((newsletter) => newsletter.tags))
  )

  const customTags = Array.from(
    new Set(newsletterList.flatMap((newsletter) => newsletter.customTags))
  ).filter(Boolean) as string[]

  const activityFormCodes = newsletterList
    .map((newsletter) => newsletter.activityFormCode)
    .filter(Boolean) as number[]

  const pkdCodes = removePkdDuplicates(
    newsletterList.flatMap((newsletter) => newsletter.pkdCodes)
  )

  const clients = newsletterList
    .flatMap((newsletter) => newsletter.receivers)
    .filter((client) => {
      if (clientIds && clientIds.length > 0) {
        return clientIds.includes(client.id as string)
      }
      return !!client.id
    })

  return (
    <ClientListModal
      isVisible={isVisible}
      isClientRemovable={isClientRemovable}
      title={
        <div>
          <h2 className="mb-2">{`${tGeneral("clients")} (${clients.length})`}</h2>
          <h4>{title}</h4>
        </div>
      }
      clients={clients}
      header={
        <div>
          <TagList
            tags={tags}
            customTags={customTags}
            activityFormCodes={activityFormCodes}
            pkdCodes={pkdCodes}
          />
        </div>
      }
      footer={
        <div className="flex justify-end">
          <Button variant="outline" size="lg" onClick={onClose}>
            {tGeneral("close")}
          </Button>
        </div>
      }
      onClientRemove={onClientRemove}
      onClose={onClose}
    />
  )
}
